// extracted by mini-css-extract-plugin
export default {"LanguagePicker":"LanguagePicker_LanguagePicker__2sgbU","Buttons":"LanguagePicker_Buttons__pXS2u","Button":"LanguagePicker_Button__J9O4a"};